import { Injectable } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {WalletService} from '../../wallet/wallet.service';
import {Principal} from '../auth/principal.service';

@Injectable()
export class PaymentSuccessService {

  constructor( private route: ActivatedRoute,
               private router: Router,
               private walletService: WalletService,
               private principal: Principal) { }

  handlePaymentSuccess(amount: any, transactionDetails: any, object: any): void {
    // Implementa la logica di successo qui

    let logging = {
      id : transactionDetails.id,
      address : transactionDetails.payer.email_address,
      name : transactionDetails.payer.name.given_name,
      surname : transactionDetails.payer.name.surname,
      email_address : transactionDetails.payer.name.email_address,
      payer_id : transactionDetails.payer.name.payer_id,
      invoice_id : transactionDetails.purchase_units[0].invoice_id,
      value : transactionDetails.purchase_units[0].amount.value,
      status : transactionDetails.status,
      create_time : transactionDetails.create_time,
      update_time : transactionDetails.update_time
    }





    let request = {
      amount: amount,
      log: JSON.stringify(logging)
    }

    console.log(request);

    this.walletService.addPaypal(request).subscribe((res) => {
      object.dataEmitter.emit(res);
    })

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/paypalButton/payment-success.service.ts